import fc from "@/firebaseConfig";
import firebase from "firebase/app";
import getDocumentTypeKey from "../../libs/getDocumentTypeKey";
import router from "@/router";
import gql from "graphql-tag";
import moment from "moment";
import _ from "lodash";

// Utility Functions
const removeDuplicatesWithSameId = (inputArray) => {
  const idSet = new Set(); 
  return inputArray.filter(item => {
    // const itemId = item.transactionid;
    const itemId = item.documentID;
    if (!idSet.has(itemId)) {
      idSet.add(itemId);
      return true;
    }
    return false;
  });
};

function sortByField(arr, field, order) {
  const multiplier = order === "desc" ? -1 : 1;
  return [...arr].sort((a, b) => {
    const aValue = a[field];
    const bValue = b[field];
    return typeof aValue === "string" && typeof bValue === "string"
      ? multiplier * aValue.localeCompare(bValue)
      : multiplier * (aValue - bValue);
  });
}

const isNumeric = (input) => /^[0-9]+$/.test(input);

const adjustDate = (inputDateString) => {
  const inputDate = new Date(inputDateString);
  const localOffset = inputDate.getTimezoneOffset() * 60000;
  return new Date(inputDate.getTime() - localOffset);
};

const removeDuplicatesAndEmptyStrings = (arr) => {
  const uniqueValues = new Set();
  return arr.filter(item => {
    if (item === '') return false;
    if (!uniqueValues.has(item)) {
      uniqueValues.add(item);
      return true;
    }
    return false;
  });
};

const getFormatedKeywordList = (_keyword, _prefixes) => {
  _prefixes = removeDuplicatesAndEmptyStrings(_prefixes);
  _keyword = _keyword.toUpperCase();
  return [
    _keyword,
    ...(_prefixes.some(prefix => _keyword.startsWith(prefix))
      ? []
      : _prefixes.map(prefix => prefix + _keyword)),
  ];
};

const getDateBefore = (inputDateString) => {
  const millisecondsBefore = 12 * 60 * 60 * 1000;
  const inputDate = new Date(inputDateString);
  return new Date(inputDate.getTime() - millisecondsBefore);
};

// Vuex Store Configuration
export default {
  namespaced: true,
  state: {
    isLoading: false,
    list: [],
    listOrigin: [],
    searchField: "transactionid",
    page: 1,
    loading: false,
    count: 0,
    keyword: "",
    fromDate: "",
    toDate: "",
    taxCondition: "",
    emptyList: true,
    stackPage: {},
    currentPageAlgolia: 0,
    docList: [],
    timePeriodsList: [],
    timePeriodsYear: [],
    taxWHBranch: [],
    docsThaiSm: [],
    summaryReport: {},
    orderBySelect: { key: "docTaxDate", value: "desc" },
    valueFilterList: ["@DownloadedXml", "not-download", "cancelled"],
    selectedList: [],
    summaryAll: null,
    filterData: {
      branchID: "",
      taxCodeTypes: {
        SS07: false,
        S07: false,
        S00: false,
        SEXEMPT: false,
      },
      submitStatus: "",
      transactionStatus: "",
      payeeName: "",
      ivType: "",
      fromDate: "",
      toDate: "",
    },
    showPaginationTemplate: true,
    mThaiSmartTaxDocListUnsubscribeObject: null,
    mThaiSmartTaxSummaryAllUnsubscribeObject: null,
    submitDocsList: [],
    taxCodes: [],
    valueAddedTaxReturn: {
      // period: "",
      // isFillingTogether: true,
      // branchId: "",
      L1SalesAmountThisMonth: 0,
      L1Checkbox: "",
      L2LessSalesSubjectToZeroTaxRate: 0,
      L3LessExemptedSales: 0,
      L4TaxableSalesAmount: 0,
      L5OutputTax: 0,
      L6PurchaseAmountThisMonth: 0,
      L6Checkbox: "",
      L7InputTax: 0,
      L8TaxPayable: 0,
      L9ExcessTaxPayable: 0,
      L10ExcessTaxPaymentCarried: 0,
      L11NetTaxPayable: 0,
      L11Checked: false,
      L12NetExcessTaxPayable: 0,
      L12Checked: false,
      L13Surcharge: 0,
      L14Penalty: 0,
      L15TotalTaxPayable: 0,
      L16TotalExcessTaxPayable: 0
    },
    valueAddedTaxReturnEachBranch: []
  },
  mutations: {
    setLoading(state, val) { state.loading = val; },
    setFromDate(state, val) { state.fromDate = val; },
    setToDate(state, val) { state.toDate = val; },
    setSearchField(state, val) { state.searchField = val; },
    setCompaniesDocs(state, val) { state.list = removeDuplicatesWithSameId(val); },
    setPage(state, val) { state.page = val; },
    setKeyword(state, val) { state.keyword = val; },
    setListOrigin(state, val) { state.listOrigin = val; },
    setEmptyList(state, val) { state.emptyList = val; },
    setStackPage(state, val) { state.stackPage = val; },
    setCurrentPageAlgolia(state, val) { state.currentPageAlgolia = val; },
    setDocList(state, val) { state.docList = val; },
    setSummaryReport(state, val) { state.summaryReport = val; },
    setOrderBySelect(state, val) { state.orderBySelect = val; },
    setValueFilterList(state, val) { state.valueFilterList = val; },
    setSelectedList(state, val) { state.selectedList = val; },
    setSummaryAll(state, val) { state.summaryAll = val; },
    setShowPaginationTemplate(state, val) { state.showPaginationTemplate = val; },
    setTimePeriods(state, val) { state.timePeriodsList = val; },
    setTimePeriodsYear(state, val) { state.timePeriodsYear = val; },
    setTaxWHBranch(state, val) { state.taxWHBranch = val; },
    setFilterData(state, val) { state.filterData = val; },
    setDocsThaiSm(state , docThaiSm) { state.docsThaiSm = docThaiSm},
    settaxCondition(state, val) { state.taxCondition = val; },
    setValueAddedTaxReturn(state, val) { state.valueAddedTaxReturn = val; },
    setTaxCodes(state, val) { state.taxCodes = val; },
    setSubmitDocsList(state, val) { state.submitDocsList = val; },
    setAddValueAddedTaxReturnEachBranch(state, val) { state.valueAddedTaxReturnEachBranch = val; },
    setIsLoading(state, val) { state.isLoading = val; },
  },
  actions: {
    updateDocs({ commit }, val) { commit("setCompaniesDocs", val); },
    getDocumentType() {
      const documentType = router.currentRoute.name.split(".");
      return documentType.length > 2 ? documentType[documentType.length - 1] : "";
    },
    setLoading({ commit }, val) { commit("setLoading", val); },
    setFromDate({ commit }, val) { commit("setFromDate", val); },
    setToDate({ commit }, val) { commit("setToDate", val); },
    setSearchField({ commit }, val) { commit("setSearchField", val); },
    setTaxCondition({ commit }, val) { commit("settaxCondition", val); },

    async getList({ rootState, commit, dispatch }, { id, isNextPage }) {
      //console.log("rootState",rootState)
      commit("setLoading", true);
      commit("setIsLoading", true);
      const pageLimitForKeyword = 250;
      let pageLimit = localStorage.getItem("pageLimit");
      pageLimit = pageLimit === "auto" ? parseInt(localStorage.getItem("pageLimitAuto")) || 10 : parseInt(pageLimit) || 10;
      const documentType = await dispatch("getDocumentType");
      // console.log('this is doctype', documentType)

      // console.log('rootState.thaismartTaxDetail.taxCondition ', rootState.thaismartTaxDetail.taxCondition)
      let query = fc.companies.doc(id).collection("DocsThaiSmartTax");
      const { searchField, orderBySelect, valueFilterList, page } = this.state.thaismartTaxDetail;

      // query = query.where("@DocType", "==","iv");
      // console.log('rootState.thaismartTaxDetail.taxCondition :', rootState.thaismartTaxDetail.taxCondition );
      if (rootState.thaismartTaxDetail.taxCondition === "Cancel") {
        query = query.where("transactionStatus", "==", rootState.thaismartTaxDetail.taxCondition);
        // query = query.where("@DocType", "=", "wh");
      } else if (rootState.thaismartTaxDetail.taxCondition !== "") {
        query = query.where("taxCondition", "==", rootState.thaismartTaxDetail.taxCondition);
        query = query.where("transactionStatus", "==", "Open");
      }
      /*
      branchID: "", // subsidiariesBranch
      taxCodeTypes: { // taxCode
        SS07: false,
        S07: false,
        S00: false,
        SEXEMPT: false,
      },
      submitStatus: "", // submitPeriod
      transactionStatus: "", // transactionStatus
      payeeName: "", // customerName
      ivType: "", // transactionType
      fromDate: "", // docDate
      toDate: "", // docDate
      */
      // console.table(this.state.thaismartTaxDetail.filterData)submitSelectedDoc
      const keyword = this.state.thaismartTax.filterData.payeeName;
      const payeeName = this.state.thaismartTaxDetail.filterData.payeeName;
      const branchID = this.state.thaismartTaxDetail.filterData.branchID;
      const fromDate = this.state.thaismartTaxDetail.filterData.fromDate;
      commit("setFromDate", fromDate);
      const toDate = this.state.thaismartTaxDetail.filterData.toDate;
      commit("setToDate", toDate);
      const ivType = this.state.thaismartTaxDetail.filterData.ivType;
      const transactionStatus = this.state.thaismartTaxDetail.filterData.transactionStatus;
      const submitStatus = this.state.thaismartTaxDetail.filterData.submitStatus;
      const taxCodeTypesTmp = this.state.thaismartTaxDetail.filterData.taxCodeTypes
      const taxCodeTypes = Object.keys(taxCodeTypesTmp).filter(key => taxCodeTypesTmp[key]);
      if (payeeName) {
        const _keyword = this.state.thaismartTaxDetail.filterData.payeeName?.trim();
        query = query.where("customerName", "==", _keyword)
        // query = query.where("customerName", ">=", _keyword)
        //   .where("customerName", "<=", _keyword + "\uf8ff")
        //   .orderBy("customerName", "asc")
        //   .limit(pageLimitForKeyword);
      }
      if (branchID) {
        const _keyword = this.state.thaismartTaxDetail.filterData.branchID;
        if (!Number.isNaN(Number.parseInt(_keyword))) {
          query = query.where("subsidiariesBranch", "==", _keyword)
        }
      }

      if (taxCodeTypes.length > 0) {
        query = query.where("taxCode", "in", taxCodeTypes);
      }

      // TODO: not sure about this
      if (ivType === "Tax Invoice") {
        query = query.where("transactionType", "==", "Invoice");
      } else if (ivType === "Abbreviated Tax Invoice") {
        query = query.where("transactionType", "==", "Abbreviated");
      }

      if (transactionStatus === "Complete") {
        query = query.where("transactionStatus", "==", "Complete");
      } else if (transactionStatus === "Cancel") {
        query = query.where("transactionStatus", "==", "Cancel");
      } else if (transactionStatus === "Pending") {
        query = query.where("transactionStatus", "==", "Pending");
      } else if (transactionStatus === "Draft") {
        query = query.where("transactionStatus", "==", "Draft");
      } else if (transactionStatus === "Open") {
        query = query.where("transactionStatus", "==", "Open");
      }

      this.state.mThaiSmartTaxDocListUnsubscribeObject = query.onSnapshot((documents) => {
            let documentsArray = [];
            if (documents.size !== 0) {
              documentsArray = documents.docs.map(doc => {
                let document = doc.data();
                document.id = doc.id;
                return document;
              }).filter(i => i["@DocType"] != "wh")
              if (toDate && fromDate) {
                if (toDate === fromDate) {
                  documentsArray = documentsArray.filter(item => {
                    return moment(item.docTaxDate.toDate()).isSame(moment(fromDate, "YYYY-MM-DD"), "dates");
                  });
                } else {
                  const fromD = moment(fromDate, "YYYY-MM-DD");
                  const toD = moment(toDate, "YYYY-MM-DD").add(1, "day");
                  documentsArray = documentsArray.filter(item => moment(item.docTaxDate.toDate()).isBetween(fromD, toD));
                }
              }


              if (submitStatus === "Not Submit") {
                documentsArray = documentsArray.filter(item => !item.submitPeriod);
              } else if (submitStatus === "Submit") {
                documentsArray = documentsArray.filter(item => item.submitPeriod);
              }

              const orderBySelected = this.state.thaismartTaxDetail.orderBySelect;
              if (orderBySelected.key && orderBySelected.key !== "ID") {
                documentsArray.sort((a, b) => {
                  if (a[orderBySelected.key] > b[orderBySelected.key]) {
                    return orderBySelected.value === "asc" ? 1 : -1;
                  }
                  if (a[orderBySelected.key] < b[orderBySelected.key]) {
                    return orderBySelected.value === "asc" ? -1 : 1;
                  }
                  return 0;
                })
              }

              const {list, page, orderBySelect} = this.state.thaismartTaxDetail;
              const startVisible = documents.docs[0];
              const lastVisible = documents.docs[documents.docs.length - 1];
              const stackPage = _.cloneDeep(this.state.thaismartTaxDetail.stackPage);
              stackPage[page] = {first: _.cloneDeep(startVisible), last: _.cloneDeep(lastVisible)};

              // const downloaded = valueFilterList.includes("@DownloadedXml");
              // const notDownload = valueFilterList.includes("not-download");

              // if (downloaded && !notDownload && (keyword || (fromDate && toDate))) {
              //   documentsArray = list.filter(item => item["@DownloadedXml"]);
              // } else if (notDownload && !downloaded && (keyword || (fromDate && toDate))) {
              //   documentsArray = list.filter(item => !item["@DownloadedXml"]);
              // }

              commit("setStackPage", stackPage);
              if (page > 1 && (keyword || fromDate)) {
                commit("setCompaniesDocs", sortByField([...list, ...documentsArray], orderBySelect.key, orderBySelect.value));
              } else {
                // console.log('this is doc array ', documentsArray)
                // console.log(removeDuplicatesWithSameId(documentsArray))
                // console.log(this.state.thaismartTaxDetail)
                commit("setCompaniesDocs", documentsArray);
              }

              commit("setListOrigin", documentsArray);
              commit("setEmptyList", false);
            } else if (documents.size === 0 && (keyword || fromDate || toDate) && page > 1) {
              // console.log(this.state.thaismartTaxDetail)
              commit("setCompaniesDocs", removeDuplicatesWithSameId(this.state.thaismartTaxDetail.list));

              //  console.log()
              commit("setListOrigin", []);
            } else {
              commit("setCompaniesDocs", []);
              commit("setListOrigin", []);
              commit("setEmptyList", true);
            }
            commit("setLoading", false);
            commit("setIsLoading", false);

          },
          (err) => {
            commit("setLoading", false);
            commit("setIsLoading", false);
          });
    },
    getDocListUnsubscribe() {
      if (this.state.mThaiSmartTaxDocListUnsubscribeObject) {
        this.state.mThaiSmartTaxDocListUnsubscribeObject();
        this.state.mThaiSmartTaxDocListUnsubscribeObject = null;
      }
    },

    updatePage({ commit }, { page }) { commit("setPage", page); },
    updateKeyword({ commit }, { keyword }) { commit("setKeyword", keyword); },
    resetKeyword({ commit }) { commit("setKeyword", ""); },
    setOrderBySelect({ commit }, { orderBySelect }) { commit("setOrderBySelect", orderBySelect); },
    setValueFilterList({ commit }, { valueFilterList }) { commit("setValueFilterList", valueFilterList); },
    setSelectedList({ commit }, { selectedList }) { commit("setSelectedList", selectedList); },
    getSummaryAll({ commit }, { companyId }) {
      if (this.state.mThaiSmartTaxSummaryAllUnsubscribeObject) {
        this.state.mThaiSmartTaxSummaryAllUnsubscribeObject();
      }
      this.state.mThaiSmartTaxSummaryAllUnsubscribeObject = fc.companies
        .doc(companyId)
        .collection("Summaries")
        .doc("all")
        .onSnapshot(allSummaries => {
          commit("setSummaryAll", allSummaries.data());
        });
    },
    getSummaryAllUnsubscribe() {
      if (this.state.mThaiSmartTaxSummaryAllUnsubscribeObject) {
        this.state.mThaiSmartTaxSummaryAllUnsubscribeObject();
        this.state.mThaiSmartTaxSummaryAllUnsubscribeObject = null;
      }
    },
    setShowPaginationTemplate({ commit }, { val }) { commit("setShowPaginationTemplate", val); },

    async fetchTimePeriods({ commit }, { companyId , year }) {
      commit("setLoading", true);

      try {
        const end = firebase.firestore.Timestamp.fromDate(new Date(`${year}-12-31T23:59:59Z`));
        //const end = firebase.firestore.Timestamp.fromDate(new Date(Date.UTC(year + 1, 0, 0, 23, 59, 59)));
        //console.log("🚀 ~ fetchTimePeriods ~ end:", end)
        const query = fc.companies
        .doc(companyId)
        .collection("SettingThaiSmartTax")
        .doc("taxTimePeriods")
        .collection("TimePeriods")
          // .where('type', '==', 'year')
          // .where('startDate', '>=', start)
        // .where('endDate', '<=', end);

        const snapshot = await query.get();

        const timePeriods = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
       // console.log(JSON.stringify(timePeriods))

        commit("setTimePeriods", timePeriods);
        commit("setLoading", false);

       // return timePeriods;
      } catch (error) {
        console.error("Error fetching time periods: ", error);
        commit("setLoading", false);
      }
    },
    async fetchTaxWHBranch({ commit }, { companyId }) {
      commit("setLoading", true);

      try {
        const docRef = fc.companies
          .doc(companyId)
          .collection("SettingThaiSmartTax")
          .doc("taxBranch");

        const docSnapshot = await docRef.get();

        if (docSnapshot.exists) {
          const branchData = {
            id: docSnapshot.id,
            ...docSnapshot.data()
          };
          //console.log("Fetched branch data:", branchData);
          commit("setTaxWHBranch", branchData);
        } else {
          //console.log("No taxWHBranch document found!");
          commit("setTaxWHBranch", null);
        }

        commit("setLoading", false);
      } catch (error) {
        commit("setLoading", false);
      }
    },
    async fetchTimePeriodsByYear({ commit }, { companyId, yearId }) {
      commit("setLoading", true);

      try {
        const yearDoc = await fc.companies
          .doc(companyId)
          .collection("SettingThaiSmartTax")
          .doc("taxTimePeriods")
          .collection("TimePeriods")
          .doc(yearId)
          .get();

        if (yearDoc.exists) {
         // console.log(`Year: ${yearDoc.id}`, yearDoc.data());

          const quarterQuery = await fc.companies
            .doc(companyId)
            .collection("SettingThaiSmartTax")
            .doc("taxTimePeriods")
            .collection("TimePeriods")
            .where('parentIndex', '==', yearDoc.id)
            .where('type', '==', 'quarter')
            .get();

          const quarters = [];
          const quarterPromises = quarterQuery.docs.map(async (quarterDoc) => {
            //console.log(`Quarter: ${quarterDoc.id}`, quarterDoc.data());

            const monthQuery = await fc.companies
              .doc(companyId)
              .collection("SettingThaiSmartTax")
              .doc("taxTimePeriods")
              .collection("TimePeriods")
              .where('parentIndex', '==', quarterDoc.id)
              .where('type', '==', 'month')
              .get();

            const months = monthQuery.docs.map(monthDoc => ({
              id: monthDoc.id,
              ...monthDoc.data(),
            }));

            quarters.push({
              id: quarterDoc.id,
              ...quarterDoc.data(),
              months,
            });
          });

          await Promise.all(quarterPromises);

          commit("setTimePeriodsYear", { yearId: yearDoc.id, quarters });
        } else {
          console.warn(`No year document found with ID: ${yearId}`);
          commit("setTimePeriodsYear", []);
        }
      } catch (error) {
        console.error("Error fetching time periods by year:", error);
      } finally {
        commit("setLoading", false);
      }
    },
    async fetchDocsThaiSm({ commit }, { companyId, taxWHCode, startDate, endDate, subsidiariesBranch }) {
      commit('setLoading', true);

      try {
        if (!companyId) {
          throw new Error('Company ID is required');
        }

        const docsThaiSmRef = fc.companies.doc(companyId).collection('DocsThaiSmartTax');

        let query = docsThaiSmRef;

        if (taxWHCode) {
          query = query.where('taxWHCode', '==', taxWHCode);
        }

        if (startDate) {
          query = query.where('docTaxDate', '>=', startDate);
        }

        if (endDate) {
         // console.log("🚀 ~ fetchDocsThaiSm ~ endDate:", endDate)
          query = query.where('docTaxDate', '<=', endDate);
        }

        if (subsidiariesBranch) {
          query = query.where('subsidiariesBranch', '==', subsidiariesBranch);
        }

        const querySnapshot = await query.get();

        if (querySnapshot.empty) {
          console.log('No matching documents found');
          commit('setDocsThaiSm', []);
          return;
        }

        const documents = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

       //console.log("Fetched documents:", documents);

        commit('setDocsThaiSm', documents);
       // return documents;
      } catch (error) {
        console.error('Error fetching documents:', error);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },

    setFilterData({ commit }, val ) { commit("setFilterData", val); },
      async submitSelectedDoc({commit, rootState}, {timePeriod, companyId}) {
          const submitAbleDocs = rootState.thaismartTaxDetail.selectedList.filter(i => !i.data.submitPeriod && !(i.data.items.filter(item => item.taxType == 2).length > 0))
          const docsRef = fc.companies
              .doc(companyId)
              .collection("DocsThaiSmartTax")
          const batch = fc.db.batch();
          for (const submitDoc of submitAbleDocs) {
              batch.update(docsRef.doc(submitDoc.data.id), {submitPeriod: timePeriod.name})
          }
          batch.commit()
      },
      async cancelSelectedDoc({commit, rootState}, {companyId}) {
          const submitAbleDocs = rootState.thaismartTaxDetail.selectedList.filter(i => i.data.submitPeriod)
          const docsRef = fc.companies
              .doc(companyId)
              .collection("DocsThaiSmartTax")

          const batch = fc.db.batch();
          for (const submitDoc of submitAbleDocs) {
              batch.update(docsRef.doc(submitDoc.data.id), {submitPeriod: ""})
          }
          batch.commit()
      },
    async fetchSubmitDocsList({commit, rootState}, {companyId, branchId, submitPeriod}){
        let query = fc.companies.doc(companyId).collection("DocsThaiSmartTax")
        .where("submitPeriod", "==", submitPeriod)
        if (branchId) {
          query = query.where("subsidiariesBranch", "==", branchId);
        }
        const ovDocs = (await query.where("@DocType", "==", "ov").get()).docs.map(doc => doc.data());
        const ivDocs = (await query.where("@DocType", "==", "iv").get()).docs.map(doc => doc.data()); 
        commit("setSubmitDocsList", [...ovDocs, ...ivDocs]);
    },
    async getTaxCodes({commit}, {companyId}) {
      const docRef = fc.companies
        .doc(companyId)
        .collection("SettingThaiSmartTax")
        .doc("taxCodeSetting");

      const docSnapshot = await docRef.get();
      if (docSnapshot.exists) {
        const data = docSnapshot.data();
        commit("setTaxCodes", data.taxCode);
      } else {
        commit("setTaxCodes", null);
      }

    },
    calculateTaxAddedValueReturn({commit, rootState}, {L10ExcessTaxPaymentCarried, L13Surcharge, L14Penalty, L1Checkbox, L6Checkbox}) {
      const submitDocsList = rootState.thaismartTaxDetail.submitDocsList;
      const valueAddedTaxReturn = calculateTaxAddedValue({
        docList: submitDocsList,
        L10ExcessTaxPaymentCarried: Number(L10ExcessTaxPaymentCarried,),
        L13Surcharge: Number(L13Surcharge),
        L14Penalty: Number(L14Penalty),
        period: submitDocsList[0]?.submitPeriod
      })

      commit("setValueAddedTaxReturn",
          {
            ...valueAddedTaxReturn,
            L1Checkbox,
            L6Checkbox,
          }
      )
      calculateTaxAddedValueEachBranch({
        docList: submitDocsList,
        L10ExcessTaxPaymentCarried: Number(L10ExcessTaxPaymentCarried,),
        L13Surcharge: Number(L13Surcharge),
        L14Penalty: Number(L14Penalty),
        period: submitDocsList[0]?.submitPeriod
      });

      commit("setAddValueAddedTaxReturnEachBranch", calculateTaxAddedValueEachBranch({
        docList: submitDocsList,
        L10ExcessTaxPaymentCarried: Number(L10ExcessTaxPaymentCarried),
        L13Surcharge: Number(L13Surcharge),
        L14Penalty: Number(L14Penalty),
        period: submitDocsList[0]?.submitPeriod,
      }))
    }
  },
};



function calculateTaxAddedValue({
                                  docList,
                                  period,
                                  L10ExcessTaxPaymentCarried = 0,
                                  L13Surcharge = 0,
                                  L14Penalty = 0
                                }) {
  const ovDocs = docList.filter((doc)=> checkIfSalesTaxSubmitOnDuePeriod(doc, period))
  const ivDocs = docList.filter((doc)=> checkIfBuyTaxSubmitOnDuePeriod(doc, period))
  // Output tax
  const L1SalesAmountThisMonth = ovDocs.reduce((acc, doc) => acc + Number(doc.items.reduce((acc, item) => Number(item.taxBaseAmount) + acc,0)), 0)

  const L2LessSalesSubjectToZeroTaxRate = (()=> {
    const taxRateZeroAndNotExempt = ovDocs.filter(checkIfHasTaxRateZeroAndNotExemptItems)
    return taxRateZeroAndNotExempt.reduce((acc, doc) => acc + Number(doc.items.filter(checkIfTaxRateZeroItem).reduce((acc, item) => acc + Number(item.taxBaseAmount), 0)
    ), 0)
  })()

  const L3LessExemptedSales = (()=>{
    const taxRateZeroAndExempt = ovDocs.filter(checkIfHasExemptItem)
    return taxRateZeroAndExempt.reduce((acc, doc) => acc + Number(doc.items.filter(item => checkIfExemptItem(item) || doc.items.length === 1).reduce((acc, item) => acc + Number(item.taxBaseAmount), 0)
    ), 0)
  })()

  const L4TaxableSalesAmount = L1SalesAmountThisMonth - L2LessSalesSubjectToZeroTaxRate - L3LessExemptedSales
  const L5OutputTax = (()=> {
    const taxRateSeven = ovDocs.filter(checkIfHasTaxRateSevenItems);
    return taxRateSeven.reduce((acc, doc) => acc + Number(doc.items.filter(checkIfTaxRateSevenItem).reduce((acc, item) => acc + Number(item.taxAmount), 0)), 0)
  })()


  // Input tax
  // Calculate total purchase amount including both regular purchases and AVG items
  const L6PurchaseAmountThisMonth = ivDocs.reduce((acc, doc) => {
    // Handle regular purchases with 7% tax rate
    const regularPurchases = doc.items.filter(checkIfTaxRateSevenItem).reduce((itemAcc, item) => 
      itemAcc + Number(item.taxBaseAmount || 0), 0);
    
    // Handle AVG purchases - only include if isAVGTax is true
    const avgPurchases = doc.isAVGTax === true ? Number(doc.taxSumBaseAmountAvg || 0) : regularPurchases;
    
    return acc + avgPurchases;
  }, 0);

  const L7InputTax = ivDocs.reduce((acc, doc) => {
    const regularL7InputTax = doc.items.reduce((acc, item) => acc + Number(item?.taxAmount || 0), 0);
    const avgPurchases = doc.isAVGTax === true ? Number(doc.taxSumAmountAvg || 0) : regularL7InputTax;

   return acc + avgPurchases;
  }, 0)


  // Value Added Tax
  const [L8TaxPayable] = (()=> {
    if (L5OutputTax > L7InputTax) {
      return [L5OutputTax - L7InputTax, true]
    }
    return [0, false]
  })()

  const [L9ExcessTaxPayable] = (()=> {
    if (L5OutputTax < L7InputTax) {
      return [L7InputTax - L5OutputTax, true]
    }
    return [0, false]
  })()

  // Net Tax
  const [L11NetTaxPayable, L11Checked] = (()=>{
    if (L8TaxPayable > L10ExcessTaxPaymentCarried) {
      return [L8TaxPayable - L10ExcessTaxPaymentCarried, true]
    }
    return [0, false]
  })()
  const [L12NetExcessTaxPayable, L12Checked] = (()=>{
    if (L11Checked) {
      return [0, false]
    }
    return [L9ExcessTaxPayable + L10ExcessTaxPaymentCarried, true]
  })()

  const L15TotalTaxPayable = (()=>{
    const L13PL14 =  L13Surcharge + L14Penalty
    if (L11Checked && L13PL14 > 0) {
      return L11NetTaxPayable + L13PL14
    } else if (L12Checked && L13PL14 > 0) {
      return L12NetExcessTaxPayable + L13PL14
    }
    return 0
  })()
  const L16TotalExcessTaxPayable = (()=>{
    if (L12Checked && L12NetExcessTaxPayable > L13Surcharge + L14Penalty) {
      return L12NetExcessTaxPayable - L13Surcharge - L14Penalty
    }
    return 0
  })()
  return (
      {
        L1SalesAmountThisMonth,
        L2LessSalesSubjectToZeroTaxRate,
        L3LessExemptedSales,
        L4TaxableSalesAmount,
        L5OutputTax,
        L6PurchaseAmountThisMonth,
        L7InputTax,
        L8TaxPayable,
        L9ExcessTaxPayable,
        L10ExcessTaxPaymentCarried,
        L11NetTaxPayable,
        L11Checked,
        L12NetExcessTaxPayable,
        L12Checked,
        L13Surcharge,
        L14Penalty,
        L15TotalTaxPayable,
        L16TotalExcessTaxPayable
      }
  )
}
function calculateTaxAddedValueEachBranch({
                                          docList,
                                          period,
                                          L10ExcessTaxPaymentCarried = 0,
                                          L13Surcharge = 0,
                                          L14Penalty = 0

                                        }) {
  const docByBranch = {}
  docList.forEach((doc) => {
    docByBranch[doc.subsidiariesBranch] = docByBranch[doc.subsidiariesBranch] || {
      docList: [],
      branchName: doc.subsidiariesAddress?.branchName || "",
      branchId: doc?.subsidiariesBranch || "",
      companyInfoName: doc?.companyInfoName || "",
      companyInfoTaxID: doc?.companyInfoTaxID || "",
      subsidiariesAddress: doc?.subsidiariesAddress || {}
    }
    docByBranch[doc.subsidiariesBranch].docList.push(doc)
  })

  const result = Object.keys(docByBranch).map((branch) => {
    return {
      branchId: docByBranch[branch].branchId,
      branchName: docByBranch[branch].branchName,
      branchAddress: docByBranch[branch].subsidiariesAddress,
      companyInfoName: docByBranch[branch].companyInfoName,
      companyInfoTaxID: docByBranch[branch].companyInfoTaxID,
      value: calculateTaxAddedValue({
        docList: docByBranch[branch].docList,
        period: period,
        L10ExcessTaxPaymentCarried: L10ExcessTaxPaymentCarried,
        L13Surcharge: L13Surcharge,
        L14Penalty: L14Penalty
      })
    }
  })
  return result
}
function checkIfTaxTaxTypeIs(inputTaxType, doc) {
  return Boolean(doc?.taxType == inputTaxType || doc.items.some(item => item?.taxType == inputTaxType))
}

function checkIfTaxRateZeroItem(item) {
  return Boolean(item.taxRate === "0.00" || item.taxRate === 0)
}

function checkIfTaxRateSevenItem(item) {
  return Boolean(item.taxRate === "7.00" || item.taxRate === 7 )
}

function checkIfHasTaxRateSevenItems(doc) {
  return Boolean(doc.items.some(checkIfTaxRateSevenItem))
}

function checkIfHasTaxRateZeroAndNotExemptItems(doc) {
   const isNotExempt = !checkIfHasExemptItem(doc)
  const isZeroRate = doc.items.some(checkIfTaxRateZeroItem)
  return isNotExempt && isZeroRate 
}
function checkIfExemptItem(item) {
  return Boolean(item?.exemptVat == 1)
}

function checkIfHasExemptItem(doc) {
  return  Boolean(doc?.exemptVat == 1 || doc.items.some(item=> checkIfExemptItem(item)))
}

function checkIfSalesTaxSubmitOnDuePeriod(doc, period) {
  return Boolean(doc['@DocType'] === 'ov' && doc['submitPeriod'] === period && doc['taxCondition'] === 'S' && checkIfTaxTaxTypeIs("1", doc))
}

function checkIfBuyTaxSubmitOnDuePeriod(doc, period) {
  return Boolean(doc['@DocType'] === 'iv' && doc['submitPeriod'] === period && (doc['taxCondition'] === 'P' || doc['taxCondition'] === 'avg' )&& checkIfTaxTaxTypeIs("1", doc))
}